'use client';

import { useEffect, useState } from 'react';
import { getSettings } from '@/lib/actions/settings';
import { AboutSettingsForm } from '@/components/admin/settings/AboutSettingsForm';

const KEYS = [
  'about_hero_image',
  'home_about_headline',
  'home_about_description',
  'about_headline',
  'about_description',
  'about_vision',
  'about_mission',
  'about_why_simisi',
  'about_overview',
  'about_values',
  'about_stats',
  'home_about_image',
  'home_stats',
];

export default function AdminAboutSettingsPage() {
  const [settings, setSettings] = useState<Awaited<ReturnType<typeof getSettings>> | null>(null);

  useEffect(() => {
    getSettings(KEYS).then(setSettings);
  }, []);

  if (!settings) {
    return null;
  }

  return (
    <div className="space-y-6">
      <AboutSettingsForm initialData={settings} />
    </div>
  );
}
